import React from 'react';

import { ButtonComponent, ChildContainer, LoadingContainer } from './button.styled';
import { type ButtonProps } from './button.types';

export function Button({
  children,
  buttonType = 'primary',
  isLoading = false,
  disabled,
  ...props
}: ButtonProps): JSX.Element {
  return (
    <ButtonComponent
      $buttonType={buttonType}
      $isDisabled={Boolean(disabled)}
      $isLoading={isLoading}
      disabled={disabled || isLoading}
      type="button"
      {...props}
    >
      <LoadingContainer>
        <svg height="35px" width="35px" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 200 200" color="#fff">
          <radialGradient id="a1" cx=".66" fx=".66" cy=".3125" fy=".3125" gradientTransform="scale(1.5)">
            <stop offset="0" stopColor="currentColor" />
            <stop offset=".3" stopColor="currentColor" stopOpacity=".9" />
            <stop offset=".6" stopColor="currentColor" stopOpacity=".8" />
            <stop offset=".8" stopColor="currentColor" stopOpacity=".4" />
            <stop offset="1" stopColor="currentColor" stopOpacity="0" />
          </radialGradient>
          <circle
            transform-origin="center"
            fill="none"
            stroke="url(#a1)"
            strokeWidth="15"
            strokeLinecap="round"
            strokeDasharray="200 1000"
            strokeDashoffset="0"
            cx="100"
            cy="100"
            r="70"
          >
            <animateTransform
              type="rotate"
              attributeName="transform"
              calcMode="spline"
              dur="2"
              values="360;0"
              keyTimes="0;1"
              keySplines="0 0 1 1"
              repeatCount="indefinite"
            />
          </circle>
          <circle
            transform-origin="center"
            fill="none"
            opacity=".2"
            stroke="#26948F"
            strokeWidth="15"
            strokeLinecap="round"
            cx="100"
            cy="100"
            r="70"
          />
        </svg>
      </LoadingContainer>
      <ChildContainer>{children}</ChildContainer>
    </ButtonComponent>
  );
}
